<template>
    <div class="Bank">
        <p class="f-Overpass f-14 f-c-midgrey remove-margin">
            Pembayaran dapat dilakukan ke salah satu rekening berikut ini
        </p>
        <div class="bank" style="text-align: center">
            <template v-for="dataBank, index in detailBayar[0].rekening">
            <div class="p-t-15" :key="index" >
                <img
                    :src="'https://res.cloudinary.com/sinadme/c_scale,h_50/' + dataBank.data_bank.logo"
                    alt="logo_bca"
                    id="img_bank"
                    class="p-t-16"
                />
                <p class="f-Overpass f-14 p-t-16 remove-margin" style="font-weight: 700; margin-top: 10px">
                    {{ dataBank.no_rekening}}
                </p>
                <p class="f-Overpass f-14 remove-margin">
                    {{ dataBank.nama_pemilik}}
                </p>
            </div>
        </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "Bank",

  data() {
    return {
      isLoading: false,
      idTraining: this.$route.params.idTraining
    };
  },
  async mounted(){
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      detailBayar: "detailBayar",
    }),
  },

  methods: {
    ...mapActions({
      getDetailBayar: `${moduleName}/getDetailBayar`,
    }),
    async init() {
      await this.getDetailBayar(this.idTraining);
    },
    }
};
</script>